import { cn } from "@/lib/utils";

type PulseDotVariant = "blue" | "green" | "gray" | "red";

interface PulseDotProps {
  variant?: PulseDotVariant;
  isAnimated?: boolean;
  className?: string;
}

const variantStyles: Record<PulseDotVariant, { outer: string; inner: string }> = {
  blue: {
    outer: "bg-blue-400",
    inner: "bg-blue-500",
  },
  green: {
    outer: "bg-green-300",
    inner: "bg-green-500",
  },
  gray: {
    outer: "bg-gray-300",
    inner: "bg-gray-500",
  },
  red: {
    outer: "bg-red-300",
    inner: "bg-red-500",
  },
};

export const PulseDot = ({ variant = "blue", isAnimated = false, className }: PulseDotProps) => {
  const styles = variantStyles[variant];

  return (
    <span className={cn("relative flex h-2 w-2", className)}>
      <span
        className={cn(
          "absolute inline-flex h-full w-full rounded-full opacity-75",
          styles.outer,
          isAnimated && "animate-ping",
        )}
      />
      <span
        className={cn(
          "absolute left-1/2 top-1/2 inline-flex h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 rounded-full",
          styles.inner,
        )}
      />
    </span>
  );
};

export default PulseDot;
